import React, { useState, useEffect } from "react"
import MultiTagView from "../../multiTag/MultiTagView"
import { DETAIL_VIEW } from "../../../utils"

function Tags(props) {
	const [tagData, setTagData] = useState({ id: props?.details?.file_id, file_name: props?.details?.name, currTag: props?.details?.tags })

	return (
		<MultiTagView
			view={DETAIL_VIEW}
			fileData={{ id: props?.details?.file_id, file_name: props?.details?.name, tags: props?.tags }}
			retainedFilterJobData={props?.retainedFilterJobData}
		/>
	)
}

export default Tags
